import { Listener } from './Listener';
export class GtmListener extends Listener {
    formStart(formName, inputName) {
        const dataLayerMkt = {
            form: {
                name: formName,
                input: inputName,
            },
            page: {
                product: window.page.product,
            },
        };
        this.pushGtmEvent('MKT Form Started', dataLayerMkt);
    }
    formNavigate(formName, formStep, navigationAction, data) {
        const dataLayerMkt = {
            form: {
                name: formName,
                step: formStep,
                input: navigationAction,
            },
        };
        this.pushGtmEvent('MKT Form Navigated', dataLayerMkt);
    }
    formSubmit(formName, data) {
        const dataLayerMkt = {
            form: {
                name: formName,
                eventId: typeof window.form === 'object' && typeof window.form.eventId === 'string'
                    ? window.form.eventId
                    : '',
            },
            page: {
                product: window.page.product,
            },
        };
        this.pushGtmEvent('MKT Form Submitted', dataLayerMkt);
    }
    chatStart() {
    }
    chatEnd() {
    }
    pushGtmEvent(eventName, dataLayerMkt) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: eventName,
            mkt: dataLayerMkt,
        });
    }
}
